import { z } from "zod";

export const sendMessageThreadSchema = (t: (key: string) => string) =>
  z.object({
    content: z.string().nonempty(t("global.form.error.mandatoryField")),
  });
export type SendMessageThreadFormValues = z.infer<ReturnType<typeof sendMessageThreadSchema>>;
